<template>
  <div id="app">
    <div class="title" style="display: none">{{ title }}</div>
    <div class="guide" v-if="showGuide">
      <div class="guide-content" :class="{ show: !showSwitch }">
        <img src="/img/home/content.png" />
        <div class="open-guide" @click="showSwitch = !showSwitch">
          <img src="/img/home/open.png" alt v-if="showSwitch" />
          <img src="/img/home/hide.png" alt v-else />
        </div>
      </div>
    </div>
    <div
      class="guide-bg"
      v-if="!showSwitch"
      @click="showSwitch = !showSwitch"
    ></div>
    <router-view />
  </div>
</template>

<style lang="scss">
@import "./xc-ui/scss/xc-ui.scss";
</style>

<script>
import { mapState, mapActions } from "vuex";

export default {
  data() {
    return {
      showSwitch: true,
      showGuide: false,
    };
  },
  computed: {
    ...mapState(["globalConfig"]),
    title() {
      let title = "";
      if (this.globalConfig && this.globalConfig.platform_name) {
        title = this.globalConfig.platform_name.value;
      }

      document.title = title;

      return title;
    },
  },
  watch: {
    $route(to, from) {
      if (this.$route.path == "/admin/program") {
        this.showGuide = true;
      } else {
        this.showGuide = false;
      }
    },
  },
  created() {
    this.$store.dispatch("getConfig");
    if (localStorage.token) {
      this.$store.dispatch("getUserInfo");
      this.$store.dispatch("getUserModule");
    }
  },
};
</script>
<style scoped lang="scss">
.guide {
  position: fixed;
  right: 0;
  height: 100%;
  z-index: 999;
}
.guide-content {
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  transition: all 0.3s;
  transform: translate3d(100%, 0, 0);
  img {
    max-width: none;
    height: 100%;
  }
}

.show {
  transform: translate3d(0, 0, 0);
}

.open-guide {
  position: absolute;
  left: -44px;
  top: 50%;
  transform: translateY(-50%);
}

.guide-bg {
  background: rgba($color: #000000, $alpha: 0.5);
  position: fixed;
  right: 0;
  top: 0;
  height: 100%;
  z-index: 998;
  width: 100%;
}
</style>
